<template>
  <v-img
    v-if="thumbExists"
    :src="thumbSrc"
    :class="['course-name', { isMember }]"
    contain
    eager
    style="background-color: transparent"
  />
</template>
<script>
import { IMPROVE_CONFIG } from "@/config.js";
import thumbSizes from "@/utils/thumbs.js";
export default {
  name: "TableThumb",
  props: {
    thumb: {
      type: Object,
      default: null
    }
  },
  computed: {
    thumbSrc: function() {
      return this.thumbExists ? this.transform(this.thumb.thumbnail.data.key) : null;
    },
    thumbExists: function() {
      return this.thumb.hasOwnProperty('thumbnail') ? true : false;
    },
    isMember: function() {
      return this.thumb.is_membership;
    },
    isSenso() {
        return this.$globalConfig.APP_NAME === 'senso';
    }
  },
  methods: {
    transform(key) {
      const existingResize =
        (thumbSizes &&
          thumbSizes.small_new &&
          thumbSizes.small_new.resize) ||
        {};

      const edits = Object.assign({}, thumbSizes.small_new, {
        resize: Object.assign({}, existingResize, {
          fit: "contain", 
          background: { r: 0, g: 0, b: 0, alpha: 0 }
        }),
        png: {}
      });

      const imageRequest = JSON.stringify({
        bucket: IMPROVE_CONFIG.BUCKET,
        key: key,
        edits: edits
      });
      return `${IMPROVE_CONFIG.SERVERLESS_IMAGE_HANDLER}/${btoa(imageRequest)}`;
    }
  }
};
</script>
<style scoped>
.course-name {
  vertical-align: middle;
  background-color: transparent !important;
  border: none;
  box-shadow: none;
}
.isMember::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 0;
    height: 0;
    border-left: 30px solid transparent;
    border-top: 30px solid #83c902;
}

.isMember::after {
    content: "";
    position: absolute;
    top: 5px;
    right: 5px;
    width: 12px;
    height: 13px;
    background-image: url(/static/safeguarding-stars.png);
    background-size: contain;
    background-repeat: no-repeat;
}
</style>